import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * Custom hook to delete a member permanently by the member id
 */
export const useDeleteMember = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const { axiosInstance } = useAxios();

  /**
   * @param {string|number} memberId - The ID of the member to delete
   * @param {() => void} [onSuccess] - Optional callback on successful delete
   */
  const deleteMember = async (memberId, onSuccess) => {
    try {
      setLoading(true);
      setError("");
      setSuccess(false);
      await axiosInstance.delete(
        `${TENANT_DOMAIN}/school/admin/member/destroy/${memberId}`,
      );
      setSuccess(true);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      setSuccess(false);
      if (error?.response?.status === 500 || error?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(error?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setError("");
    setSuccess(false);
  };

  return { deleteMember, loading, error, success, resetState };
};
